import React, {useState} from 'react';
import {
    Avatar,
    Card,
    CardContent,
    CardHeader,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import styled from "@emotion/styled";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import Span from "@jumbo/shared/Span";
import JumboListItem from "@jumbo/components/JumboList/components/JumboListItem";
import JumboChipsGroup from "@jumbo/components/JumboChipsGroup";
import {useJumboDialog} from "@jumbo/components/JumboDialog/hooks/useJumboDialog";
import ParentDetail from "./ParentDetail";
import JumboGridItem from "@jumbo/components/JumboList/components/JumboGridItem";
import DDImage from "../../../component/DDImage";
import PhoneIcon from "@mui/icons-material/Phone";
import {useParentContext} from "./context";
import {useTranslation} from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import moment from "moment/moment";
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';


const Item = styled(Span)(({theme}) => ({
    minWidth: 0,
    flexGrow: 0,
    padding: theme.spacing(0, 1),
}));

const ContactItem = ({parent, view}) => {
    const {showDialog, hideDialog} = useJumboDialog();
    const {globalState, setGlobalState} = useParentContext();
    const [parentListRefresh, setContactsListRefresh] = useState();
    const [favorite, setFavorite] = React.useState(parent?.starred);
    const {t} = useTranslation();
    const deleteContactMutation = async () => {
        return null
    }

    const hideDialogAndRefreshContactsList = React.useCallback(() => {
        hideDialog();
        setContactsListRefresh(true);
    }, [hideDialog, setContactsListRefresh]);


    const showContactDetail = React.useCallback(() => {
        showDialog({
            content: <ParentDetail parent={parent} onClose={hideDialog}/>
        })
    }, [showDialog, parent]);


    const handleItemAction = (menuItem) => {
        switch (menuItem.action) {
            case 'edit':
                setGlobalState({...globalState,parent, openAddEdit : true})
                break;

            case 'info':
               setGlobalState({...globalState,parent, openChildInfo: true})
                break;

            case 'purchaseInfo':
            setGlobalState({...globalState, parent, openPurchaseInfo: true})
                break;

            case 'reservationInfo':
                setGlobalState({...globalState, parent, openReservationInfo: true})
                break;
            {/*case 'delete':
                showDialog({
                    variant: 'confirm',
                    title: 'Are you sure about deleting this parent?',
                    content: "You won't be able to recover this parent later",
                    onYes: () => deleteContactMutation.mutate(parent),
                    onNo: hideDialog
                })*/}
        }
    };

    if (view === "grid") {
        return (
            <JumboGridItem xs={12} lg={6}>
                <Card variant="outlined" elevation={0}>
                    <CardHeader
                        avatar={parent.images?.length > 0 ? (
                                <DDImage path={parent.images[0]} alt={parent.firstName + ' ' + parent.lastName}/>) :
                            (<Avatar alt={parent.firstName + ' ' + parent.lastName}/>)
                        }
                        action={
                            <React.Fragment>
                                <JumboDdMenu
                                    icon={<MoreHorizIcon/>}
                                    menuItems={[
                                        {icon: <EditIcon/>, title: "Edit1", action: "edit"},
                                        {icon:<InfoOutlinedIcon/>, title: "Child Info", action:"info"},
                                        {icon:<ShoppingCartOutlinedIcon/>, title: "Purchase Info", action:"purchaseInfo"},
                                        {icon:<BookOutlinedIcon/>, title: "Reservation Info", action:"reservationInfo"}

                                    ]}
                                    onClickCallback={handleItemAction}
                                />
                            </React.Fragment>
                        }
                        title={
                            <Typography
                                variant={"h6"}
                                color={"text.primary"}
                                mb={.25}
                            >
                                {parent.firstName} {parent.lastName}
                            </Typography>}
                        subheader={
                            <Typography
                                variant={"body1"}
                                color={"text.secondary"}
                            >
                                {parent.designation}
                            </Typography>}
                    />
                    <CardContent sx={{pt: 0}}>
                        <Divider sx={{mb: 2}}/>
                        <List disablePadding>
                            {/*<ListItem sx={{p: theme => theme.spacing(.75, 1.5)}}>
                                <ListItemIcon sx={{minWidth: 50}}>
                                    <BusinessIcon/>
                                </ListItemIcon>
                                <ListItemText
                                    primary={parent.company}
                                />
                            </ListItem>*/}
                            <ListItem sx={{px: 1.5}}>
                                <ListItemIcon sx={{minWidth: 50}}>
                                    <AlternateEmailIcon/>
                                </ListItemIcon>
                                <ListItemText
                                    primary={parent.email}
                                />
                            </ListItem>
                            <ListItem sx={{px: 1.5}}>
                                <ListItemIcon sx={{minWidth: 50}}>
                                    <PhoneIcon/>
                                </ListItemIcon>
                                <ListItemText
                                    primary={parent?.phone?.fullNumber}
                                />
                            </ListItem>
                        </List>
                        <Divider sx={{my: 2}}/>
                        <Stack direction={"row"} alignItems={"center"} sx={{minWidth: 0}}>
                            <Item >
                                {parent?.active ? (
                                    <JumboChipsGroup
                                        chips={[{label: t('calendar.active')}]}
                                        mapKeys={{label: "name"}}
                                        spacing={1}
                                        size={"small"}
                                        defaultColor={"#008000"}
                                    />
                                ) : (
                                    <JumboChipsGroup
                                        chips={[{label: t('calendar.deActive')}]}
                                        mapKeys={{label: "name"}}
                                        spacing={1}
                                        size={"small"}
                                        defaultColor={"#FF0000"}
                                    />
                                )
                                }
                            </Item>


                        </Stack>
                    </CardContent>
                </Card>
            </JumboGridItem>
        )
    }
    return (
        <React.Fragment>
            <JumboListItem
                componentElement={"div"}
                itemData={parent}
                secondaryAction={
                    <JumboDdMenu
                        icon={<MoreHorizIcon/>}
                        menuItems={[
                            {icon: <EditIcon/>, title: "Edit", action: "edit"},
                            {icon:<InfoOutlinedIcon/>, title: "Child Info", action:"info"},
                            {icon:<ShoppingCartOutlinedIcon/>, title: "Purchase Info", action:"purchaseInfo"},
                            {icon:<BookOutlinedIcon/>, title: "Reservation Info", action:"reservationInfo"}

                        ]}
                        onClickCallback={handleItemAction}
                    />
                }
                sx={{
                    cursor: 'pointer',
                    borderTop: 1,
                    borderColor: 'divider',
                    '&:hover': {
                        bgcolor: 'action.hover',
                    }
                }}
            >

                <ListItemAvatar onClick={showContactDetail}>
                    {parent.images?.length > 0 ? (
                            <DDImage path={parent.images[0]} alt={parent.firstName + ' ' + parent.lastName}/>) :
                        (<Avatar alt={parent.firstName + ' ' + parent.lastName}/>)}
                </ListItemAvatar>
                <ListItemText
                    onClick={showContactDetail}
                    primary={
                        <Typography variant={"body1"} component={"div"}>
                            <Stack direction={"row"} alignItems={"center"} sx={{minWidth: 0}}>
                                <Item
                                    sx={{
                                        flexBasis: {xs: '100%', sm: '50%', md: '25%'}
                                    }}
                                >
                                    <Typography variant={"h5"} fontSize={14} lineHeight={1.25} mb={0}
                                                noWrap>{parent.firstName} {parent.lastName}</Typography>
                                    <Typography
                                        variant={"body1"}
                                        noWrap
                                        color={'text.secondary'}

                                    >
                                        {moment(parent.createdAt).format('DD/MM/YYYY, hh:mm A')}
                                    </Typography>
                                </Item>
                                <Item
                                    sx={{
                                        flexBasis: {sm: '50%', md: '28%'}, //28
                                        display: {xs: 'none', sm: 'block'}
                                    }}
                                >
                                    <Typography variant={"body1"} noWrap={false}>{parent.email}</Typography>
                                </Item>
                                <Item
                                    sx={{
                                        flexBasis: {md: '25%'},
                                        display: {xs: 'none', md: 'block'}
                                    }}
                                >
                                    <Typography variant={"body1"} noWrap>{parent?.phone?.fullNumber}</Typography>
                                </Item>
                                <Item
                                    sx={{
                                        flexBasis: {md: '12%'},
                                        display: {xs: 'none', md: 'block'}
                                    }}
                                >
                                    {parent?.active ? (
                                        <JumboChipsGroup
                                            chips={[{label: t('calendar.active')}]}
                                            mapKeys={{label: "name"}}
                                            spacing={1}
                                            size={"small"}
                                            defaultColor={"#008000"}
                                        />
                                    ) : (
                                        <JumboChipsGroup
                                            chips={[{label: t('calendar.deActive')}]}
                                            mapKeys={{label: "name"}}
                                            spacing={1}
                                            size={"small"}
                                            defaultColor={"#FF0000"}
                                        />
                                    )
                                    }
                                </Item>
                            </Stack>
                        </Typography>
                    }
                />
            </JumboListItem>
        </React.Fragment>
    );
};
/* Todo parent, view prop define */
export default ContactItem;
